import { mapState } from 'vuex';
import preview from "../preview/index.vue";

export default {
    name: 'podcasts_list',
    props: {
        scroll : Number
    },

    components : {
        preview
    },

    data : function(){

        return {
			loading : false,
			searchvalue : '',
			count : 0,
			sort : 'date_desc',
			sorting : {

				date_asc : {
					text : 'date_asc',
					field : 'ss.date',
					sort : 'asc'
				},
				date_desc : {
					text : 'date_desc',
					field : 'ss.date',
					sort : 'desc'
				}
			},


		}

    },

    created : () => {

    },

    watch: {
		tscrolly : function(){

			if (this.$refs['list']){

				if (this.$refs['list'].height() - 1000 < this.tscrolly + this.dheight){
					this.$refs['list'].next()
				}
				
			}
			
		}
	},
    computed: mapState({
        dheight: state => state.dheight,
        tscrolly : function(state){
            return this.scroll || state.tscrolly
        },
        auth : state => state.auth,
        userinfo : state => state.userinfo?.userinfo,

        admin : function(){
            return this.core.user.checkFeatures(['admin'])
        },
        

        payload : function(){

            var p = {
                sortFields : [{
                    field : this.sorting[this.sort].field,
                    order : this.sorting[this.sort].sort
                }],
                fieldsFilter : {
                }
            }

            if(this.searchvalue){
                p.fieldsFilter['si.searchvalue'] = {
                    match : true,
                    fields : ['si.topic', 'si.summary'],
                    value : this.searchvalue
                }
            }

            if(!this.admin){
                p.fieldsFilter.deleted = 0
            }


            if(this.auth){
                p.fieldsFilter['si.age'] = {
                    value : this.userinfo.ageCluster[1],
                    instr : true
                }
            }

            p.fieldsFilter = {
				...p.fieldsFilter,
			}

            console.log('p.fieldsFilter', p.fieldsFilter)
        
            return p
        },

        api : function(){

            return 'podcasts.list'
            
        }
    }),

    methods : {


        reload : function(){
            if(this.$refs['list']) this.$refs['list'].reload()
        },

        search : function(v){
            this.searchvalue = v
        },

        setcount : function(v){
            console.log('setcount', v)
            this.count = v
        },

        sortchange : function(v){
            this.sort = v
        },

    },
}